/* eslint-disable id-match */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { CYF_BOOKING_STEP_ONE } from '../../../../config/text/text';
import { getPassengerOptions } from '../../../../helpers/booking';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const BookingCalendarPassengers = ({ initialQuantity, onQuantityChange }) => {
  const [selectedValue, setSelectedValue] = useState(initialQuantity);
  const values = getPassengerOptions();
  const onChange = (event) => {
    setSelectedValue(event.target.value);
    onQuantityChange(event.target.value);
  };

  return (
    <>
      <CustomNativeSelect
        ariaLabel={CYF_BOOKING_STEP_ONE}
        /* eslint-disable-next-line react/forbid-component-props */
        className="full-width margin"
        id="num-passengers"
        onChange={onChange}
        value={selectedValue}
      >
        {values.map((item) => {
          return (
            <option key={item.quantity} value={item.quantity}>
              {item.label}
            </option>
          );
        })}
      </CustomNativeSelect>
    </>
  );
};

BookingCalendarPassengers.propTypes = {
  initialQuantity: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
};

export default BookingCalendarPassengers;
